import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Los textos para nuestro idioma
const resources = {
  en: {
    translation: {
      "nav": {
        "dashboard": "Dashboard",
        "catalog": "Catalog",
        "orders": "Orders",
        "categories": "Categories",
        "inventory": "Inventory",
        "marketing": "Marketing",
        "coupons": "Coupons",
        "profile": "Profile",
        "menu": "Menu"
      },
      "layout": {
        "home": "Home",
        "plans": "Plans",
        "pos_terminal": "POS Terminal",
        "notifications": "Notifications",
        "support": "Support",
        "login": "Login",
        "impersonating": "⚠️ You are viewing the system as:",
        "exit_impersonation": "Exit Client Mode",
        "customize_menu": "Customize Menu",
        "finish": "Finish",
        "customize": "Customize"
      },
      "settings": {
        "platform_settings": "Platform Settings",
        "appearance": "Appearance",
        "light": "Light",
        "dark": "Dark",
        "language": "Language",
        "language_en": "English",
        "language_es": "Español",
        "store_settings": "Store Settings"
      }
    }
  },
  es: {
    translation: {
      "nav": {
        "dashboard": "Panel",
        "catalog": "Catálogo",
        "orders": "Pedidos",
        "categories": "Categorías",
        "inventory": "Inventario",
        "marketing": "Marketing",
        "coupons": "Cupones",
        "profile": "Perfil",
        "menu": "Menú"
      },
      "layout": {
        "home": "Inicio",
        "plans": "Planes",
        "pos_terminal": "Terminal POS",
        "notifications": "Notificaciones",
        "support": "Soporte",
        "login": "Iniciar Sesión",
        "impersonating": "⚠️ Estás viendo el sistema como:",
        "exit_impersonation": "Salir del Modo Cliente",
        "customize_menu": "Personalizar Menú",
        "finish": "Terminar",
        "customize": "Personalizar"
      },
      "settings": {
        "platform_settings": "Ajustes de Plataforma",
        "appearance": "Apariencia",
        "light": "Claro",
        "dark": "Oscuro",
        "language": "Idioma",
        "language_en": "English",
        "language_es": "Español",
        "store_settings": "Configuración de Tienda"
      }
    }
  }
};

const savedLanguage = localStorage.getItem('language') || 'es';

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: savedLanguage, // language to use, more information here: https://www.i18next.com/overview/configuration-options#languages-namespaces-resources
    fallbackLng: "es",

    interpolation: {
      escapeValue: false // react already safes from xss
    }
  });

export default i18n;
